
import { Options, Vue } from "vue-class-component";

@Options({
  components: {}
})
export default class ClientsV2 extends Vue {
  // Tabs
  get tabs() {
    return [
      {
        name: "client-registration",
        title: this.$t("clientManagement.tabs.clientRegistration").toString()
      },
      {
        name: "client-management",
        title: this.$t("clientManagement.tabs.clientManagement").toString()
      }
    ];
  }

  changeTabs(value: string) {
    this.$router.push({
      name: value
    });
  }

  isTabActive(name: string) {
    return name === this.$route.name;
  }
}
